import React, { Fragment, useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Link,
  NavLink,
  Route
} from 'react-router-dom';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  ThemeProvider,
  Nav,
  NavItem,
  NavBrand,
  Navbar,
  PopupMenu,
  Toast
} from 'quantux-ui';
import DMDrawer from './components/dm-drawer';
// User theme and user theme colors
import { theme, blue, salmon, gray } from './theme';
// Pages
import KitchenSink from './pages/KitchenSink';
import Home from './pages/Home';
import AdminProfile from './pages/AdminProfile';
import UserProfile from './pages/UserProfile';
import Search from './pages/ Search';
import Legal from './pages/Legal';
import Settings from './pages/Settings';
import Chat from './pages/Chat';
import Schedule from './pages/Schedule';
// Local components
import SignInMenu from './components/menus/signin-menu';
import UserMenu from './components/menus/user-menu';
import SignInDialog from './components/dialogs/signin-dialog';
import ResetPasswordDialog from './components/dialogs/reset-password-dialog';
import TwoFactorAuthDialog from './components/dialogs/two-factor-auth-dialog';
import PracticeDashboard from './components/practice-dashboard/practice-dashboard';
import ProviderDashboard from './components/provider-dashboard/provider-dashboard';
import FacilityDashboard from './components/facility-dashboard/facility-dashboard';
import PayerDashboard from './components/payer-dashboard';
import PatientDashboard from './components/patient-dashboard';
import CompanyDashboard from './components/company-dashboard';
import OldCaseDashboard from './components/case-dashboard';
import ScheduleCaseDrawer from './components/case-schedule/schedule-case-drawer';
import ScheduleCaseDashboard from './components/case-schedule/schedule-case-dashboard';
import CaseDashboard from './components/case-schedule/case-dashboard';
// import CaseDashboard from './components/case-dashboard';
import SiteMap from './components/site-map';
import NotificationsDrawer from './components/notifications-drawer';
import PrivateRoute from './components/private-route';

// Actions
import {
  toggleUserSigninDialog,
  isUserSignedIn,
  toggleResetPasswordDialog,
  hideAlert,
  getNotifications,
  setNotificationsCount,
  addAppAlert,
  logout,
  toggleDmDrawer,
  updateChat,
  clearChatBadge
} from './actions';
// Images
import medprosLogoLarge from './imgs/medProsLogoLarge.svg';
import { BASE_URL, debugLogToConsole, titleCase } from './utils';
import TestPage from './pages/Test';

const App = props => {
  const [isMobileScreen, setMobileScreen] = useState(false);
  const [isUserMenuVisible, setUserMenuVisibility] = useState(false);
  const [showSiteMap, toggleSiteMap] = useState(false);
  const [showNotificationsDrawer, toggleNotificationsDrawer] = useState(false);
  const [storedAppAlert, setStoredAppAlert] = useState(JSON.parse(localStorage.getItem('alerts')));
  const [events, setEvents] = useState([]);
  const [showUserInfoOnNavbar, setShowUserInfoOnNavbar] = useState(true);
  const [medProsMessages, setMedProsMessages] = useState([]);
  let medProsEventSource;

  // Refs
  const userIcon = React.createRef();
  // Effects
  useEffect(() => {
    window.addEventListener('resize', handleDocResize);
    setMobileScreen(window.innerWidth < 480);
    props.isUserSignedIn();
    return () => {
      window.removeEventListener('resize', handleDocResize);
    };
  }, []);

  // useEffect(() => {
  //   if (props.isSignedIn) {
  //     const userId = props.usr._id;
  //     if (!medProsEventSource) {
  //       // Regsiter for SSE
  //       medProsEventSource = new EventSource(
  //         `${BASE_URL}/events/public/${userId}`, {
  //           withCredentials: true
  //         }
  //       );
  //       medProsEventSource.onmessage = (e) => {
  //         const { data } = e;
  //         const eventDataObject = JSON.parse(data);
  //         setMedProsMessages((prvState) => prvState.concat(eventDataObject));
  //         const { eventType, msg, providerFullName = '' } = eventDataObject;
  //         if (eventType === 'info') {
  //           props.addAppAlert({
  //             headerText: titleCase(eventType),
  //             headerIcon: 'fa fa-info-circle',
  //             bodyText: msg,
  //             showAlert: true,
  //             autoDismiss: true,
  //             autoDismissTime: 5000
  //           });
  //         } else if (eventType === 'action') {
  //           if (msg.toLowerCase() === 'logout') {
  //             props.logout({
  //               headerText: 'Account Logout',
  //               headerIcon: 'fa fa-exclamation-triangle',
  //               bodyText: 'You are logged out by MedPros Admin.',
  //               showAlert: true,
  //               autoDismiss: true,
  //               autoDismissTime: 5000
  //             });
  //           }

  //           if (msg.toLowerCase() === 'reloadaccesspermissions') {
  //             props.addAppAlert({
  //               headerText: 'Access Permissions Updated',
  //               headerIcon: 'fa fa-info-circle',
  //               bodyText: 'Medpros Admin has updated your access permissions.',
  //               showAlert: true,
  //               autoDismiss: true,
  //               autoDismissTime: 5000
  //             });
  //             if (window.location.pathname.startsWith('/practice')) {
  //               window.location.reload();
  //             }
  //           }

  //           if (msg.toLowerCase() === 'reloadprovideraccesspermissions') {
  //             props.addAppAlert({
  //               headerText: 'Provider Access Permissions Updated',
  //               headerIcon: 'fa fa-info-circle',
  //               bodyText: `${providerFullName} has updated your access permissions.`,
  //               showAlert: true,
  //               autoDismiss: true,
  //               autoDismissTime: 5000
  //             });
  //             if (window.location.pathname.startsWith('/provider')) {
  //               window.location.reload();
  //             }
  //           }

  //           if (msg.toLowerCase() === 'updatechat') {
  //             const { lastMessage, dmId } = eventDataObject;
  //             props.updateChat(dmId, lastMessage);
  //           }
  //         }
  //       };
  //     }
  //   } else {
  //     if (medProsEventSource) {
  //       medProsEventSource.close();
  //     };
  //   }
  // }, [props.isSignedIn]);

  // Handler methods
  const handleDocResize = () => {
    setMobileScreen(window.innerWidth < 480);
  };

  // Styles
  const styles = StyleSheet.create({
    navbarBrandImage: {
      minHeight: '24px'
    },
    navbarBrandImageLarge: {
      // display: isMobileScreen ? 'none' : 'block'
      display: props.isSignedIn && isMobileScreen ? 'none' : 'block'
    },
    navbarBrandImageSmall: {
      display: props.isSignedIn && isMobileScreen ? 'block' : ''
    },
    navIcons: {
      fontSize: '24px'
    },
    medprosAssistant: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      position: 'absolute',
      // background: "rgb(0, 160, 255)",
      background: gray[800],
      // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)"
      boxShadow: "rgb(0, 160, 255) 0px 3px 100px"
    },
    navbarUserName: {
      color: 'yellow',
      fontSize: '14px',
      fontWeight: 'bold',
      paddingTop: '2px'
    },
    navbarUserNameIcon: {
      position: 'relative',
      color: salmon[500],
      top: '-6px'
    }
  });

  const handleOnDismissAlert = (id) => {
    props.hideAlert(id);
  };

  const handleOnCloseNotification = () => {
    setEvents([]);
  };

  // Toasts
  const toasts = [];
  props.appAlerts.forEach((el) => {
    if (el.showAlert) {
      if (el.autoDismiss) {
        setTimeout(() => {
          handleOnDismissAlert(el.id);
        }, el.autoDismissTime);
      }

      toasts.push(
        <Toast
          key={el.id}
          id={el.id}
          top="41"
          bottom={null}
          headerText={el.headerText}
          headerIcon={el.headerIcon}
          bodyText={el.bodyText}
          onDismiss={handleOnDismissAlert}
          showFooter={false}
        />
      );
    }
  });

  const eventToasts = [];
  events.forEach((el) => {
    if (el.autoDismiss) {
      setTimeout(() => {
        handleOnCloseNotification();
      }, el.autoDismissTime);
    }

    eventToasts.push(
      <Toast
        key={el.id}
        id={el.id}
        top="41"
        bottom={null}
        headerText={el.headerText}
        headerIcon={el.headerIcon}
        bodyText={el.bodyText}
        onDismiss={() => {
          handleOnCloseNotification();
        }}
        showFooter={false}
      />
    );
  });

  // Stored app alerts
  if (storedAppAlert) {
    if (storedAppAlert.showAlert) {
      if (storedAppAlert.autoDismiss) {
        setTimeout(() => {
          setStoredAppAlert(null);
          localStorage.removeItem('alerts');
        }, storedAppAlert.autoDismissTime);
      }

      toasts.push(
        <Toast
          key={storedAppAlert.id}
          id={storedAppAlert.id}
          top="41"
          bottom={null}
          headerText={storedAppAlert.headerText}
          headerIcon={storedAppAlert.headerIcon}
          bodyText={storedAppAlert.bodyText}
          onDismiss={() => {
            localStorage.removeItem('alerts');
            setStoredAppAlert(null);
          }}
          showFooter={false}
        />
      );
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Fragment>
          <PopupMenu
            top={41}
            right={1}
            left={null}
            visible={isUserMenuVisible}
            parent={userIcon}
            onOutsideClick={() => { setUserMenuVisibility(false); }}
            zIndex='2000'
            position="fixed"
          >
            {props.isSignedIn
              ? <UserMenu setVisibility={setUserMenuVisibility} />
              : <SignInMenu onCloseMenu={setUserMenuVisibility} />
            }
          </PopupMenu>
          {/* fixed-top & sticky disabled for now */}
          <Navbar
            className='sticky-top-nav'
          >
            <NavBrand>
              <Link to="/">
                <div className="fx">
                  {/* <img
                    alt="Quantux Logo Small"
                    src={medprosLogoSmall}
                    className={css(styles.navbarBrandImage, styles.navbarBrandImageSmall)}
                  /> */}
                  <div
                    className="blue-text"
                    style={{
                      marginLeft: '4px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <img
                      alt="Quantux Logo Large"
                      src={medprosLogoLarge}
                      className={css(styles.navbarBrandImage, styles.navbarBrandImageLarge)}
                    />
                  </div>
                </div>
              </Link>
              {props.isSignedIn && showUserInfoOnNavbar &&
                <div className={css(styles.navbarUserName)}>
                  {`${props.usr.displayName}${props.usr.credentials && props.usr.credentials.length > 0 ? `, ${props.usr.credentials}` : ''}`}
                  <i
                    className={`ml-2 fa fa-times-circle font-12 ${css(styles.navbarUserNameIcon)}`}
                    onClick={() => setShowUserInfoOnNavbar(false)}
                  />
                </div>
              }
            </NavBrand>
            <Nav
              style={{
                justifyContent: props.isSignedIn && isMobileScreen ? 'space-between' : 'flex-end',
                width: props.isSignedIn && isMobileScreen ? '100vw' : ''
              }}
            >
              {/* Navbar sitemap */}
              <NavItem
                className='mr-3'
                onClick={() => toggleSiteMap(!showSiteMap)}
              >
                <i
                  className={`fa fa-bars ${css(styles.navIcons)}`}
                />
              </NavItem>

              {/* Navbar Search */}
              <NavLink
                to='/search'
                component={NavItem}
                className='mr-3'
                activeClassName='selected'
              >
                <i
                  className={`fa fa-search ${css(styles.navIcons)}`}
                  style={{ color: 'inherit' }}
                />
              </NavLink>

              {/* Chat messages */}
              {/* {props.isSignedIn
                ? <NavLink
                  to='/chat'
                  component={NavItem}
                  className='mr-3'
                  activeClassName='selected'
                >
                  <i
                    className={`fa fa-comments ${css(styles.navIcons)}`}
                  />
                  {props.showChatIconBadge
                    ? <i
                      className='fa fa-exclamation-circle'
                      style={{
                        position: 'relative',
                        top: '-7px',
                        left: '-12px',
                        fontSize: '16px',
                        color: salmon[500],
                        borderRadius: '30%',
                        cursor: 'pointer',
                        minWidth: '12px',
                        textAlign: 'center'
                      }}
                    />
                    : null
                  }
                </NavLink>
                : null
              } */}
              {/* DM Drawer */}
              {props.isSignedIn
                ? <NavItem className='mr-3'>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingLeft: props.notificationsCount > 0 ? '9px' : ''
                    }}
                  >
                    <i
                      className={`fa fa-comments ${css(styles.navIcons)}`}
                      onClick={() => {
                        props.toggleDmDrawer(true);
                        props.clearChatBadge();
                      }}
                    />
                    {props.showChatIconBadge &&
                      <i
                        className='fa fa-exclamation-circle'
                        style={{
                          position: 'relative',
                          top: '-7px',
                          left: '-12px',
                          fontSize: '16px',
                          color: salmon[500],
                          borderRadius: '30%',
                          cursor: 'pointer',
                          minWidth: '12px',
                          textAlign: 'center'
                        }}
                      />
                    }
                  </div>
                </NavItem>
                : null
              }
              {/* Navbar Notifications */}
              {props.isSignedIn
                ? <NavItem
                  className='mr-3'
                  onClick={() => {
                    props.setNotificationsCount(0);
                    toggleNotificationsDrawer(!showNotificationsDrawer);
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingLeft: props.notificationsCount > 0 ? '9px' : ''
                    }}
                  >
                    <i className={`fa fa-bell ${css(styles.navIcons)}`} />
                    {props.notificationsCount && props.notificationsCount > 0
                      ? <span
                        onClick={() => {
                          props.setNotificationsCount(0);
                          toggleNotificationsDrawer(!showNotificationsDrawer);
                        }}
                        style={{
                          position: 'relative',
                          top: '-7px',
                          left: '-12px',
                          fontSize: '10px',
                          background: blue[500],
                          color: 'white',
                          borderRadius: '30%',
                          cursor: 'pointer',
                          minWidth: '12px',
                          textAlign: 'center'
                        }}
                      >
                        {props.notificationsCount}
                      </span>
                      : null
                    }
                  </div>
                </NavItem>
                : null
              }

              {/* User icon and menu */}
              <NavItem
                onClick={() => {
                  if (props.isSignedIn) {
                    setUserMenuVisibility(!isUserMenuVisible);
                  } else {
                    props.toggleUserSigninDialog(true);
                    // window.location = `${window.location.origin}/login/true/false`;
                    // history.push('/login/true/false');
                  }
                }}
                className={props.isSignedIn ? 'mr-3' : ''}
              >
                <div
                  ref={userIcon}
                  style={{ height: '32px', fill: 'inherit' }}
                >
                  {props.usr && props.usr.avatarImageUrl
                    ? <img
                      src={props.usr.avatarImageUrl}
                      alt="avatar"
                      style={{
                        width: 'auto',
                        height: '32px',
                        maxHeight: '32px',
                        borderRadius: '5px'
                      }}
                    />
                    : <svg
                      width="32"
                      height="32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: 'inherit' }}
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 0a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm20.5 9.5c0 3.32-2.68 6-6 6s-6-2.68-6-6 2.68-6 6-6 6 2.68 6 6Zm-18 16c0-4 8-6.2 12-6.2s12 2.2 12 6.2v2h-24v-2Z"
                      />
                    </svg>
                  }
                  {/* Popup menu was here ...... */}
                </div>
              </NavItem>

              {/* Schedule */}
              {props.isSignedIn
                ? <NavLink
                  to='/schedule'
                  component={NavItem}
                  className='mr-3'
                  activeClassName='selected'
                >
                  <i className={`fa fa-calendar ${css(styles.navIcons)}`} />
                </NavLink>
                : null
              }
              {/* {props.isSignedIn
                ? <NavItem>
                    <i className={`fa fa-calendar ${css(styles.navIcons)}`} />
                  </NavItem>
                : null
              } */}
            </Nav>
          </Navbar>

          {/* Site Map */}
          <SiteMap
            showSiteMap={showSiteMap}
            closeSiteMap={() => toggleSiteMap(false)}
          />

          {/* Notificatiosn drawer */}
          {showNotificationsDrawer
            ? <NotificationsDrawer
              showNotificationsDrawer={showNotificationsDrawer}
              closeNotificationsDrawer={() => toggleNotificationsDrawer(false)}
            />
            : null
          }

          {/* Signin Dialog */}
          {props.isUserSigninDialogVisible
            ? <SignInDialog
              onCloseDialogBox={() => { props.toggleUserSigninDialog(false); }}
              isVisible={props.isUserSigninDialogVisible}
              showLoginErrorMsg={props.showLoginErrorMsg}
            />
            : null
          }

          {/* Password Reset Dialog */}
          {props.isResetPasswordDialogVisible
            ? <ResetPasswordDialog
              onCloseDialogBox={() => { props.toggleResetPasswordDialog(false); }}
              isVisible={props.isResetPasswordDialogVisible}
              showLoginErrorMsg={props.showInvalidEmailErrorMsg}
            />
            : null
          }

          {/* 2FA Auth Dialog */}
          {props.is2FaVerificationDialogVisible ? <TwoFactorAuthDialog /> : null}

          {/* App alerts */}
          {toasts}
          {eventToasts}

          {/* Show send DM drawewr */}
          {props.isSignedIn &&
            <DMDrawer
              isVisible={props.showDmDrawer}
              onClose={() => {
                props.toggleDmDrawer(false);
              }}
            />
          }

          {/* Medpros Assistant */}
          <div
            style={{
              display: 'none',
              position: 'absolute',
              right: '0',
              bottom: '0',
              width: '75px',
              height: '100px'
            }}
          >
            <div className={`bounce-in-bottom ${css(styles.medprosAssistant)}`} />
          </div>

          <Switch>
            <Route path='/login/:signInMenu/:_2faMenu'><Home /></Route>
            <Route path='/kitchensink'><KitchenSink /></Route>
            <Route path='/test'>
              <TestPage />
            </Route>
            <PrivateRoute path='/admin'><AdminProfile /></PrivateRoute>
            <PrivateRoute path='/user'><UserProfile /></PrivateRoute>
            <PrivateRoute path='/provider/:providerId'><ProviderDashboard /></PrivateRoute>
            <PrivateRoute path='/practice/:practiceNpi'><PracticeDashboard /></PrivateRoute>
            <PrivateRoute path='/facility/:facilityNpi'><FacilityDashboard /></PrivateRoute>
            <PrivateRoute path='/company/:companyId'><CompanyDashboard /></PrivateRoute>
            <PrivateRoute path='/payer/:payerId'><PayerDashboard /></PrivateRoute>
            <PrivateRoute path='/patient/:patientId'><PatientDashboard /></PrivateRoute>
            <PrivateRoute path='/case2/:caseId'><OldCaseDashboard /></PrivateRoute>
            <PrivateRoute path='/case/:caseId'><CaseDashboard /></PrivateRoute>
            <PrivateRoute path='/search'><Search /></PrivateRoute>
            <PrivateRoute path='/settings'><Settings /></PrivateRoute>
            <PrivateRoute path='/chat'><Chat /></PrivateRoute>
            {/* Case Schedules */}
            <PrivateRoute path='/schedule/:scheduleId/:readOnly'><ScheduleCaseDashboard /></PrivateRoute>
            <PrivateRoute path='/schedule/create'><ScheduleCaseDrawer /></PrivateRoute>
            <PrivateRoute path='/schedule'><Schedule /></PrivateRoute>
            <Route path='/legal/:tab'><Legal /></Route>
            <Route path='/'><Home /></Route>
          </Switch>
        </Fragment>
      </Router>
    </ThemeProvider>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(
  mapStateToProps, {
    toggleUserSigninDialog,
    isUserSignedIn,
    toggleResetPasswordDialog,
    hideAlert,
    getNotifications,
    setNotificationsCount,
    addAppAlert,
    logout,
    toggleDmDrawer,
    updateChat,
    clearChatBadge
  })(App);
